// Fontes restritas a famílias com equivalente instalado no servidor
// (Liberation/DejaVu) para o PDF sair fiel ao editor.
export const FONT_OPTIONS = [
  "Times New Roman",
  "Arial",
  "Courier New",
  "Georgia",
];

export const FONT_SIZES = [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24];

export const DEFAULT_PAGE_CONFIG = {
  paperSize: "A4",
  margins: { top: 2.5, right: 2, bottom: 2.5, left: 3 },
  fontFamily: "Times New Roman",
  fontSize: 12,
};
